export interface RefreshSessionRequest1 {
    id:string
    issuedAt:string
    expiresAt:string
    clientName:string
    clientAuthenticationMethods:string
    authorizationGrantTypes:string
    redirectUris:string
    postLogoutRedirectUris:string
    scopes:string
    clientSettings:string
    isEnabled:boolean

  }


 export interface RefreshSessionRequest {
    refreshTokenstring:string
 } 

 export interface InitiateSessionResponse {
    diasporaSessionToken:string
    refreshToken:boolean
    expiresIninteger:number
    tokenType:string
    scopesExpand: string[]
    activationStatus:string
 }
 
export enum ActivationStatus {
   ACTIVE = "ACTIVE",
   ACTIVATION_ALREADY_ACTIVE = "ACTIVATION_ALREADY_ACTIVE",
   NOT_STARTED = "NOT_STARTED",
   PENDING_LINK = "PENDING_LINK"
 }

 export interface InitiateSessionRequest {
    mobileAccessToken:string
    correlationId:string
 }

 export interface CustomerActivationRequest {
    countryOfResidence:string
    country:string
    preferredCurrency:string   
 }


 export interface CustomerActivationResponse {
    activationId:string
    diasporaReferenceId:string
    status:string
    walletLinkId:string
    walletMsisdn:string
    walletCurrency:string
    homeMarket:string
    firstName:string
    lastName:string
    linkedAt:string
 }


 export interface AuthTokenRequest {
    clientId:string
    clientSecret:string
    grantType:string
 }

 export interface AuthTokenResponse {
    accessToken:string
    tokenType:string
    expiresIn:number
 }

 export interface OrchestrationResponse {
    flowCode:string
    action:string
    status:string
    data:DataResponse
 }

 export interface ConfirmOrchestrationResponse {
   flowCode:string
   action:string
   status:string
   data: ConfirmDataResponse
 }


 export interface ConfirmDataResponse {
   debitReference:string,
   transactionId:string,
   message:string
 }

 export interface PaymentDetails {
    bankLocation: string,
    purpose: string,
    currency: Currency,
    sourceCurrency:Currency,
    targetCurrency:Currency,
    rate: number,
    amount: number,
    converted: number,
    time: 'Up to 24 hours',
    cost: number,
    quoteId: string,
    transactionId: string,
    bankRedirectUrl: string
 }
 
 export interface DiasporaStagingResponse {
   id:string
   correlationId:string
   partnerId:string
   status:CompletionOrderStatus
   thunesOrderStatus:OrderStatus
   customerId:string
   walletLinkId:string
   sourceAmount:number
   sourceCurrency:string
   receiveAmount:number
   receiveCurrency:string
   debitReference:string
   bankRedirectUrl:string
   countryCode:string
   flowCode:string
   fxRate:number
   fees:number
   createdAt:string
   updatedAt:string
 }

 export interface DataResponse {
   customerId:string
   quotationId:string
   debitReference:string
   bankRedirectUrl:string
   sourceAmount:number
   sourceCurrency:Currency
   creditedAmount:number
   creditedCurrency:Currency
   fxRate:number
   fees:number
   expiresAt:string
   correlationId:string
   message:string
   limits:CorridorLimits
 }

 export interface CorridorLimits {
   currencyDetails?: CurrencyDetails[]
   corridorLimits?: {
     currencyDetails?: CurrencyDetails[]
   }
   singleTransactionLimits?: {
     currencyDetails?: any[]
   }
   result?: string
   message?: string
 }

 export interface CurrencyDetails {
   minAmount:number
   maxAmount: number
   currency: Currency
 }

 /*{
   corridorLimits:object
   singleTransactionLimits:object
   transactionAmountLimit:number
   result:string
   message:string
 }*/

 export interface OrchestrationRequest {
   flowCode: FlowCode,
   action: Action,
   quoteId: string,
   amount: Amount,
   purposeOfFunds: string,
   countryOfResidence: string,
   referenceCurrency: number
 }

 export enum FlowCode{
      DW_BANK_TOPUP_THUNES = "DW_BANK_TOPUP_THUNES"
 }

 export enum Action{
   QUOTE = "QUOTE",
   CONFIRM = "CONFIRM"
 }

 export interface Amount {
   value: number,
   currency: Currency
 }

 export enum Currency {
   AED = "AED",
   AFN = "AFN",
   ALL = "ALL",
   AMD = "AMD",
   ANG = "ANG",
   AOA = "AOA",
   ARS = "ARS",
   AUD = "AUD",
   AWG = "AWG",
   AZN = "AZN",
   BAM = "BAM",
   BBD = "BBD",
   BDT = "BDT",
   BGN = "BGN",
   BHD = "BHD",
   BIF = "BIF",
   BMD = "BMD",
   BND = "BND",
   BOB = "BOB",
   BRL = "BRL",
   BSD = "BSD",
   BTN = "BTN",
   BWP = "BWP",
   BYN = "BYN",
   BZD = "BZD",
   CAD = "CAD",
   CDF = "CDF",
   CFA = "CFA",
   CHF = "CHF",
   CLP = "CLP",
   CNY = "CNY",
   COP = "COP",
   CRC = "CRC",
   CUP = "CUP",
   CVE = "CVE",
   CZK = "CZK",
   DJF = "DJF",
   DKK = "DKK",
   DOP = "DOP",
   DZD = "DZD",
   EGP = "EGP",
   ERN = "ERN",
   ETB = "ETB",
   EUR = "EUR",
   FJD = "FJD",
   FKP = "FKP",
   FOK = "FOK",
   GBP = "GBP",
   GEL = "GEL",
   GGP = "GGP",
   GHS = "GHS",
   GIP = "GIP",
   GMD = "GMD",
   GNF = "GNF",
   GTQ = "GTQ",
   GYD = "GYD",
   HKD = "HKD",
   HNL = "HNL",
   HRK = "HRK",
   HTG = "HTG",
   HUF = "HUF",
   IDR = "IDR",
   ILS = "ILS",
   IMP = "IMP",
   INR = "INR",
   IQD = "IQD",
   IRR = "IRR",
   ISK = "ISK",
   JEP = "JEP",
   JMD = "JMD",
   JOD = "JOD",
   JPY = "JPY",
   KES = "KES",
   KGS = "KGS",
   KHR = "KHR",
   KID = "KID",
   KMF = "KMF",
   KRW = "KRW",
   KWD = "KWD",
   KYD = "KYD",
   KZT = "KZT",
   LAK = "LAK",
   LBP = "LBP",
   LKR = "LKR",
   LRD = "LRD",
   LSL = "LSL",
   LYD = "LYD",
   MAD = "MAD",
   MDL = "MDL",
   MGA = "MGA",
   MKD = "MKD",
   MMK = "MMK",
   MNT = "MNT",
   MOP = "MOP",
   MRU = "MRU",
   MUR = "MUR",
   MVR = "MVR",
   MWK = "MWK",
   MXN = "MXN",
   MYR = "MYR",
   MZN = "MZN",
   NAD = "NAD",
   NGN = "NGN",
   NIO = "NIO",
   NOK = "NOK",
   NPR = "NPR",
   NZD = "NZD",
   OMR = "OMR",
   PAB = "PAB",
   PEN = "PEN",
   PGK = "PGK",
   PHP = "PHP",
   PKR = "PKR",
   PLN = "PLN",
   PYG = "PYG",
   QAR = "QAR",
   RON = "RON",
   RSD = "RSD",
   RUB = "RUB",
   RWF = "RWF",
   SAR = "SAR",
   SBD = "SBD",
   SCR = "SCR",
   SDG = "SDG",
   SEK = "SEK",
   SGD = "SGD",
   SHP = "SHP",
   SLL = "SLL",
   SOS = "SOS",
   SPL = "SPL",
   SRD = "SRD",
   SSP = "SSP",
   STN = "STN",
   SYP = "SYP",
   SZL = "SZL",
   THB = "THB",
   TJS = "TJS",
   TMT = "TMT",
   TND = "TND",
   TOP = "TOP",
   TRY = "TRY",
   TTD = "TTD",
   TVD = "TVD",
   TWD = "TWD",
   TZS = "TZS",
   UAH = "UAH",
   UGX = "UGX",
   USD = "USD",
   UYU = "UYU",
   UZS = "UZS",
   VEF = "VEF",
   VND = "VND",
   VUV = "VUV",
   WST = "WST",
   XAF = "XAF",
   XCD = "XCD",
   XDR = "XDR",
   XOF = "XOF",
   XPF = "XPF",
   YER = "YER",
   ZAR = "ZAR",
   ZMW = "ZMW",
   ZWL = "ZWL"
}

export interface PaymentResponse{
   id: string,
   correlationId: string,
   partnerId: string,
   status: CompletionOrderStatus,
   customerId: string,
   walletLinkId: string,
   sourceAmount: number,
   sourceCurrency: Currency,
   receiveAmount: number,
   receiveCurrency: Currency,
   debitReference: string,
   bankRedirectUrl: string,
   countryCode: string,
   flowCode: FlowCode,
   fxRate: number,
   fees: number,
   createdAt: string,
   updatedAt: string   
}


export interface CompletionUpdateRequest{

   orderStatus:CompletionOrderStatus
}

export enum CompletionOrderStatus{
   PENDING_SUBMISSION = "PENDING_SUBMISSION",
   INITIATED = "INITIATED",
   PENDING_BANK = "PENDING_BANK",
   ACKNOWLEDGED = "ACKNOWLEDGED",
   FAILED = "FAILED",
   COMPLETED = "COMPLETED"
   
}

 export interface StagingUpdateRequest {
    paymentOrderId:string
    bankRedirectUrl:string
    orderStatus:OrderStatus
    partnerId:string
 }

 export enum OrderStatus{
   CREATED = "CREATED",
   ADDING_PAYMENT_METHODS = "ADDING_PAYMENT_METHODS",
   AUTHORIZING = "AUTHORIZING",
   REFUSED = "REFUSED",
   ABORTED = "ABORTED",
   AUTHORIZED = "AUTHORIZED",
   CHARGING = "CHARGING",
   CHARGED = "CHARGED",
   CANCELLING = "CANCELLING",
   CANCELLED = "CANCELLED",
   REFUNDING = "REFUNDING",
   REFUNDED = "REFUNDED",
   ERROR = "ERROR"
 }



 export interface AuthTokenResponse {
    accessToken:string
    tokenType:string
    expiresIn:number
 }

 export interface ThunesPaymentOrderResponse {
   id:string
   external_id:string
   status:string
   payment_url:string
   creation_date:string
}


export interface PartnerValidationErrorResponse{
   error: {
     code: string,
     message: string,
     target: string,
     processEventType: ProcessEventType,
     responseType: ResponseType,
     systemResponseType: SystemResponseType
   }
 }

 export enum ProcessEventType {
   VALIDATION = "VALIDATION",
   PAYMENT = "PAYMENT",
   CALLBACK = "CALLBACK"
 }

 export enum ResponseType {
   SUCCESS = "SUCCESS",
   FAILURE = "FAILURE"
 }

 export enum SystemResponseType {
   SUCCESS = "SUCCESS",
   EXCEPTION = "EXCEPTION",
   SYSTEM_ERROR = "SYSTEM_ERROR",
   ERROR = "ERROR"
 }

 export enum StatusMode {
  REAL_TIME = "REAL_TIME",
  SAVED = "SAVED"
 }

 export enum ErrorCode {
    WALLET_CONNECTOR_FAILED = "WALLET_CONNECTOR_FAILED",
    WALLET_INACTIVE = "WALLET_INACTIVE",
    WALLET_LINK_INELIGIBLE = "WALLET_LINK_INELIGIBLE",
    WALLET_NOT_LINKED = "WALLET_NOT_LINKED",
    THUNES_GET_QUOTE_FAILED = "THUNES_GET_QUOTE_FAILED",
    QUOTATION_NOT_FOUND = "QUOTATION_NOT_FOUND",
    QUOTATION_EXPIRED = "QUOTATION_EXPIRED",
    THUNES_UNEXPECTED_ERROR = "THUNES_UNEXPECTED_ERROR"
 }